import { render } from "./watch-list.vue?vue&type=template&id=184e58f2&scoped=true"
import script from "./watch-list.vue?vue&type=script&lang=js"
export * from "./watch-list.vue?vue&type=script&lang=js"

import "./watch-list.vue?vue&type=style&index=0&id=184e58f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184e58f2"]])

export default __exports__